import { Pricelist } from "features/Pricelist/Pricelist";
import { Opt } from "features/Opt/Opt"; // файл не должен так называться, это SinglePriceList

import styles from "./styles.module.scss";

export const PricesPage = (): JSX.Element => (
  <div className={styles.main}>
    <Pricelist />
    <Opt />
  </div>
);
